import React from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import AnimalsPage from './pages/AnimalsPage';
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';
import SecretAdminPanel from './pages/SecretAdminPanel';
import WhatsAppFloat from './components/WhatsAppFloat';

function AppContent() {
  const location = useLocation();
  const isPersonelPanel = location.pathname === '/panel';

  return (
    <ErrorBoundary>
      <div className="App">
        {!isPersonelPanel && <Header />}
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/hizmetler" element={<ServicesPage />} />
            <Route path="/hayvanlar" element={<AnimalsPage />} />
            <Route path="/iletisim" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/panel" element={<SecretAdminPanel />} />
            <Route path="/sultanlar2025" element={<Navigate to="/panel" replace />} />
          </Routes>
        </main>
        {!isPersonelPanel && <Footer />}
        {!isPersonelPanel && <WhatsAppFloat />}
      </div>
    </ErrorBoundary>
  );
}

function App() {
  return <AppContent />;
}

export default App; 